<template>
  <v-card>
    <v-card-title>
      Invoice
      <v-spacer />
      <!-- Commented out as iframe has built-in download functionality -->
      <!-- <v-btn v-if="proforma" @click="download" color="warning" depressed>
        Download
        <v-icon>mdi-cloud-download</v-icon>
      </v-btn> -->
      <v-btn
        v-if="service && service.receiptNo === ''"
        @click="pay"
        depressed
        class="ml-2"
        color="primary"
      >
        Pay Now
        <v-icon>mdi-cash</v-icon>
      </v-btn>
    </v-card-title>
    
    <!-- PDF Viewer Iframe (Desktop) / Mobile Placeholder -->
    <v-card-text
      v-if="proforma"
      class="pa-0"
      style="height: 80vh; min-height: 700px; position: relative; background: #525659"
      :style="{
        height: isMobile ? 'auto' : '80vh',
        minHeight: isMobile ? '300px' : '700px',
        position: 'relative',
        background: isMobile ? '#ffffff' : '#525659'
      }"
    >
      <!-- Loader while Blob URL is being created/loaded -->
      <div v-if="!pdfUrl" class="pa-4 white" style="height: 100%">
        <v-skeleton-loader type="image" height="100%" />
      </div>

      <template v-else>
        <!-- Mobile Optimized View -->
        <div v-if="isMobile" class="pa-12 text-center d-flex flex-column align-center justify-center">
          <v-icon size="100" color="primary lighten-4">mdi-file-pdf-box</v-icon>
          <div class="mt-6 grey--text text--darken-2 headline font-weight-bold">
            Invoice Preview
          </div>
          <div class="mt-2 grey--text subtitle-1 mb-8">
            Your invoice is ready. Since you are on a mobile device, please use the button below to view it.
          </div>
          <v-btn
            x-large
            color="primary"
            class="text-none px-8 rounded-lg shadow-lg"
            @click="openPdfInNewTab"
          >
            <v-icon left>mdi-eye</v-icon>
            Open Invoice
          </v-btn>
          <div class="mt-4 grey--text caption">
            The document will open in your device's native PDF viewer.
          </div>
        </div>

        <!-- Desktop Iframe View -->
        <iframe
          v-else
          :src="pdfUrl"
          width="100%"
          height="100%"
          frameborder="0"
          style="border: none; display: block"
          title="Invoice Viewer"
          loading="lazy"
        ></iframe>
      </template>
    </v-card-text>
    <v-card-text v-else class="pa-4">
      <v-skeleton-loader type="image" height="700px" />
    </v-card-text>
    <Checkout />
  </v-card>
</template>

<script>
import Checkout from "@kinetics254/paygate/src/views/Checkout.vue";
import PdfViewerMixin from "../../../mixins/PdfViewerMixin";

export default {
  name: "LicenseInvoice",
  components: { Checkout },
  mixins: [PdfViewerMixin],
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("License/getLicence", v.$route.params.code);
      v.$store.dispatch("License/getProforma", v.$route.params.code);
    });
  },
  watch: {
    proforma: {
      handler(val) {
        if (val) {
          this.generatePdfUrl(val);
        }
      },
      immediate: true,
    },
  },
  computed: {
    proforma() {
      return this.$store.getters["License/licenseGetters"]("proforma");
    },

    service() {
      let service = this.$store.getters["License/licenseGetters"](
        "licenses"
      ).filter((s) => {
        return s.licenseApplicationNo === this.$route.params.code;
      });
      return service.pop();
    },
  },
  methods: {
    download: function () {
      let path = `data:application/pdf;base64,${this.proforma}`;
      Event.$emit("downloadfile", { code: `Proforma`, path });
    },

    pay: function () {
      let payload = {
        payerID: this.service.profileID,
        sourceDocumentNo: this.service.licenseApplicationNo,
        description: "License fees",
        amount: this.service.amount,
        accountNo: "",
        success_url: `${process.env.VUE_APP_URL}/${
          this.$router.resolve({ name: "LicenseList" }).href
        }`,
        fail_url: window.location.href,
      };

      payload = btoa(JSON.stringify(payload));
      // window.location.href = `${process.env.VUE_APP_PAYGATE_CHECKOUT_URL}/?payload=${payload}`;
      this.$checkout.pay(payload);
    },
  },
};
</script>

<style scoped>
iframe {
  border: none;
}

::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
